import I18n from 'I18n';
import { ChirpError } from 'rpc-client-utils';
export function extractInviteErrorType(error) {
  var _networkError$cause, _networkError;
  // rpc-client-utils spreads rpcError fields onto ChirpError, then wraps it as
  // syncStackError.cause. Apollo adds one more layer via networkError.
  const chirpError = (_networkError$cause = error === null || error === void 0 || (_networkError = error.networkError) === null || _networkError === void 0 ? void 0 : _networkError.cause) !== null && _networkError$cause !== void 0 ? _networkError$cause : error === null || error === void 0 ? void 0 : error.cause;
  if (chirpError instanceof ChirpError) {
    return chirpError.errorType;
  }
  return undefined;
}
export function getInviteErrorMessage(error) {
  switch (extractInviteErrorType(error)) {
    case 'DUPLICATE_INVITATION':
      return I18n.text('app.shareModal.errorDuplicateInvitation');
    case 'INVITATION_PREVIOUSLY_ACCEPTED':
      return I18n.text('app.shareModal.errorPreviouslyAccepted');
    case 'MAXIMUM_USERS_INVITED':
      return I18n.text('app.shareModal.errorMaximumUsers');
    case 'UNAUTHORIZED_INVITER':
      return I18n.text('app.shareModal.errorUnauthorizedInviter');
    case 'INVITATIONS_DISABLED':
      return I18n.text('app.shareModal.errorInvitationsDisabled');
    case 'INVALID_ROLE':
      return I18n.text('app.shareModal.errorInvalidRole');
    default:
      return I18n.text('app.shareModal.errorInviteGeneric');
  }
}